export default "__VITE_ASSET__D0KoM8i6__"